import { useState } from "react";
import headerList from "../data";
import headerImage from "../assets/foods.png";
import Foods from "../components/menu/Foods";


import PopularMenu from "../components/PopularMenu";
import About from "../components/About";
import Menu from "../components/Menu";
import Testimonials from "../components/Testimonials";
import DownloadApp from "../components/DownloadApp";
import Footer from "../components/Footer";

import avatar from "../assets/avatar.png";
import { useStateValue } from "../context/StateProvider";

function Home({addToCart, handleBusket}) {
  
  return (
    <>
      

      <header className="header">
        <div className="max-w-screen-xl mx-auto px-6 relative md:-mt-20">
          

          <div className="row items-center pt-28 xl:pt-20 -ml-5">
            <div className="header-left-col">
              <h4 className="header-badge">drink food and enjoy</h4>
              <h1 className="main-heading">
                Most fastest food
                <span className="header-delivery">Delivery</span> service
              </h1>
              <p className="header-para">
                Food consumed to provide neutrational support for an organism
              </p>
              <ul className="header-customers">
                {headerList.map((each) => (
                  <li className="header-customer-li">
                    <img
                      src={each.image}
                      className="header-customer-img"
                      alt="customers"
                    />
                  </li>
                ))}
                <li className="header-customers-msg">3500+ happy customers</li>
              </ul>
            </div>

            <div className="right-col">
              <img src={headerImage} alt="" className="header-image" />
            </div>
          </div>
        </div>
      </header>

      
      <div className="max-w-7xl mx-auto space-y-20 py-10 px-4 xl:px-0">
        <PopularMenu addToCart={addToCart} handleBusket={handleBusket}/>
      </div>

      <div className="max-w-7xl mx-auto space-y-20 py-10 px-4 xl:px-0">
        <About />
      </div>

      <div className="max-w-7xl mx-auto space-y-20 py-10 px-4 xl:px-0">
        <Foods addToCart={addToCart} handleBusket={handleBusket}/>
      </div>

      <div className="max-w-7xl mx-auto space-y-20 py-10 px-4 xl:px-0">
        <h1 className="text-4xl tracking-wider font-bold">
          <span className="border-b-4 border-green-800">Our</span> Customers
        </h1>

        <Testimonials />
      </div>

      <div className="">
        <DownloadApp />
      </div>

      <div className="max-w-7xl mx-auto space-y-20 py-10 px-4 xl:px-0">
        <Footer />
      </div>
    </>
  );
}

export default Home;
